/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetBookingAccountProfilePathParameters } from 'api/actions/get-booking-account-profile/get-booking-account-profile-path-parameters';
import { GetBookingAccountProfileResponse } from 'api/actions/get-booking-account-profile/get-booking-account-profile-response';

type GetBookingAccountProfileQueryParameters = Record<string, any>;

/**
 * The path of the GetBookingAccountProfile action.
 */
export const getBookingAccountProfileActionPath = new SweetPath<keyof GetBookingAccountProfilePathParameters>(
  '/reservations/account/profile',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetBookingAccountProfile actions.
 */
export default function createGetBookingAccountProfileAction(axios: AxiosInstance) {
  return function getBookingAccountProfileAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GetBookingAccountProfileQueryParameters } = {}) {
    const path = getBookingAccountProfileActionPath.original;

    return axios.get<GetBookingAccountProfileResponse, GetBookingAccountProfileResponse>(path, {
      params: query,
      headers,
    });
  };
}
